import types from "./ActionTypes";
// import coursesListToMap from "Utils/CoursesListToMap";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import { store } from "Store";
import log from "loglevel";

export function getUser() {
  const state = store.getState();
  return state.userInfo;
}

export function loadCoursesListRequest() {
  return async (dispatch) => {
    const user = store.getState();

    let coursesListUrl = "/courseware/api/student_courses/";
    try {
      const response = await httpService.get(constants.base_url + coursesListUrl, {
        headers: {
          Authorization: `Token ${user.userInfo.token}`,
        },
      });
      log.log(response);
      if (response.status === 200) {
        let coursesList = response.data.courses;
        let coursesMap = coursesList;
        log.log({coursesList});
        dispatch(loadCoursesListSuccess(coursesMap));
      }

      // return fetch(coursesListUrl)
      //     .then(response => response.json())
      //     .then(courses => {
      //         let coursesList = JSON.parse(courses['courses']);
      //         let coursesMap = coursesListToMap(coursesList);
      //         dispatch(loadCoursesListSuccess(coursesMap));
      //     }).catch(error => {
      //         throw (error);
      //     });
    } catch (err) {
      log.log(err);
    }
  };
}

export function unRegisterCourseRequest(courseId) {
  return async (dispatch) => {
    let url = `/courseware/api/course/${courseId}/deregister`;
    try {
      await fetch(url);
      dispatch(unRegisterCourseSuccess(courseId));
      displayGlobalMessage("The course was successfully unenrolled", "success");
    } catch (error) {
      displayGlobalMessage("The course could not be unenrolled", "error");
      throw error;
    }
  };
}

export function unRegisterCourseSuccess(courseId) {
  return { type: types.UNREGISTER_COURSE_SUCCESS, courseId };
}

export function loadCoursesListSuccess(studentCoursesMap) {
  return { type: types.LOAD_STUDENT_COURSES_LIST_SUCCESS, studentCoursesMap };
}

export function loadCoursesListFailure() {
  return { type: types.LOAD_STUDENT_COURSES_LIST_FAILURE };
}
